import React from 'react';
import i18next from 'i18next';
import c from 'classnames';

import { SearchFacets, SearchFacetMenuSelect } from '@uncinc/react-searchkit';
import type { SearchFacetsProps } from '@uncinc/react-searchkit/dist/components/Facets';
import type { SearchFacetMenuSelectProps } from '@uncinc/react-searchkit/dist/components/Facets/MenuSelect';

import './style.scss';

const SearchAllContentFacetItem: React.FC<SearchFacetMenuSelectProps> = ({
  className,
  attribute,
  ...props
}) => {
  const translation = i18next.t(`components.search.facets.${attribute}.title`);

  return (
    <div className="SearchAllContentFacetItem ">
      <label
        className="SearchAllContentFacetItem__title"
        htmlFor={`refinementList_${attribute}`}
      >
        {translation}
      </label>
      <SearchFacetMenuSelect
        className={c('WebformWrapper', className)}
        attribute={attribute}
        placeholder={translation.toUpperCase()}
        {...props}
      />
    </div>
  );
};

const SearchAllContentFacets: React.FC<SearchFacetsProps> = (props) => (
  <SearchFacets className="SearchAllContentFacets" {...props}>
    <div className="row">
      <div className="col-12 col-lg-6 Facet--item">
        <SearchAllContentFacetItem
          attribute="sector_name"
          sortBy={['name:asc']}
        />
      </div>
      <div className="col-12 col-lg-6 Facet--item">
        <SearchAllContentFacetItem
          attribute="region_name"
          sortBy={['name:asc']}
        />
      </div>
    </div>
  </SearchFacets>
);

export default SearchAllContentFacets;
